module.exports = __webpack_public_path__ + "static/media/obc-placeholder.b1de6137.png";